var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 39,
    viewBox: "0 0 32 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.65616 30.6139H0.449219V6.72728C0.449219 2.24243 2.55573 0 6.76874 0H10.5401C13.0203 0 14.7871 0.815427 15.8403 2.44628C16.8256 0.815427 18.5924 0 21.1406 0H24.9119C29.1249 0 31.2314 2.24243 31.2314 6.72728V33.4835H24.0965V6.11571C24.0965 5.8439 23.9945 5.60606 23.7907 5.40221C23.6208 5.19835 23.4 5.09642 23.1281 5.09642H20.3761C20.1043 5.09642 19.8665 5.19835 19.6626 5.40221C19.4927 5.60606 19.4078 5.8439 19.4078 6.11571V33.4835H12.2728V6.11571C12.2728 5.8439 12.1709 5.60606 11.9671 5.40221C11.7972 5.19835 11.5763 5.09642 11.3045 5.09642H8.55248C8.28067 5.09642 8.04284 5.19835 7.83898 5.40221C7.6691 5.60606 7.58416 5.8439 7.58416 6.11571L6.65616 30.6139Z",
    fill: "url(#paint0_linear_697_8643)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.07012 0C7.35288 0 7.58211 0.22923 7.58211 0.512001V31.5445C7.58211 31.8273 7.35288 32.0565 7.07012 32.0565H0.527619C0.244852 32.0565 0.015625 31.8273 0.015625 31.5445V0.512002C0.015625 0.229232 0.244853 0 0.527619 0H7.07012Z",
    fill: "url(#paint1_linear_697_8643)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33953 38.2073C3.52583 38.5931 4.07535 38.5932 4.26165 38.2073L7.5086 31.4827C7.67275 31.1427 7.42506 30.748 7.04754 30.748H0.553646C0.176123 30.748 -0.0715682 31.1427 0.0925843 31.4827L3.33953 38.2073Z",
    fill: "#F89391"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.12012 32.1507C5.40289 32.1507 5.63211 31.9214 5.63211 31.6387C5.63211 31.3559 5.40289 31.1267 5.12012 31.1267L5.12012 32.1507ZM5.12012 31.1267L0.000163123 31.1267L0.000163034 32.1507L5.12012 32.1507L5.12012 31.1267Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_697_8643",
    x1: 15.8403,
    y1: 0,
    x2: 15.8403,
    y2: 33.4833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8F4E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502157,
    stopColor: "#53937C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D4039"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_697_8643",
    x1: 3.58287,
    y1: -1.68373e-9,
    x2: 3.60334,
    y2: 30.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4F1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491208,
    stopColor: "#619F88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9090"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.29a5b5fd3e77a5decd0b38c491269ae8.svg";
export { ForwardRef as ReactComponent };